// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"f8533c98","732":"4def5133"}[chunkId] + ".chunk.js";
};